var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('tiny-editor',{ref:"editor",attrs:{"init":_vm.editorConfig,"api-key":"y4jogowaxy47b99e6974w6mcy3tav2zikhkccn8iugbwzj2b"},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }